import React, { ComponentType } from 'react';

import { getContentTypeConfig } from './utils/config';
import type { ContentTypeObjectChildren } from './types/pbTypes';

/**
 * Render the content type component
 * @param Component
 * @param data
 */
const renderContentType = (Component: ComponentType, data: ContentTypeObjectChildren) => {
    return (
        <Component {...data}>
            {data?.children?.map((child) => (
                <ContentTypeFactory key={child.uniqueID} data={child} />
            ))}
        </Component>
    );
};

/**
 * Factory to render the correct content type component
 * @param data
 * @constructor
 */
type ContentTypeFactoryProps = {
    data: ContentTypeObjectChildren;
};

const ContentTypeFactory = (props: ContentTypeFactoryProps) => {
    if (!props.data.contentType) {
        console.error(`Data did not include: ${props.data.contentType}`);

        return null;
    }

    if (props.data?.isHidden) {
        return null;
    }

    const contentTypeConfig = getContentTypeConfig(props.data.contentType);

    if (contentTypeConfig && contentTypeConfig.component) {
        return renderContentType(contentTypeConfig.component, props.data);
    }

    console.error(`No component found for content type: ${props.data.contentType}`);

    return null;
};

export default ContentTypeFactory;
